import React, { useEffect, useState } from 'react'
import { GlobalTable, HeaderLine, Td, Th, Tr } from '../../../../components/styles/table-style'
import axios from 'axios'
import { OrderType } from '../AddOrder'
import { AddProductButton } from '../AddOrder/style'
import { useNavigate } from 'react-router-dom'

const SteelOrdersTable = () => {
  const [ orders, setOrders ] = useState<OrderType[]>([])
  const navigate = useNavigate()
  
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_STEEL_ORDERS_BASE_URL}/order`)
      .then(response => {
        if(response.data) setOrders(response.data)
      })
      .catch(error => console.error(error))
  }, [])
  
  return (
    <GlobalTable>
      <thead>
        <HeaderLine>
          <Th>Número do pedido</Th>
          <Th></Th>
        </HeaderLine>
      </thead>
      <tbody>
        {orders.map((item, index) => 
          <Tr key={index}>
            <Td>{item.id}</Td>
            <Td>
              <AddProductButton onClick={() => navigate(`${item.id}`)}>Visualizar pedido</AddProductButton>
            </Td>
          </Tr>
        )}
      </tbody>
    </GlobalTable>
  )
}

export default SteelOrdersTable